import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Administrator
// Component:
// ----------------------------------------------

//const ADDRS_API = config.COMP_API + '/campaigns';
const ADDRS_API = config.API;
const FILTER_KEY1 = 'filter-pub-type';
const FILTER_KEY2 = 'filter-pub-device';
const FILTER_KEY3 = 'filter-pub-country';
const FILTER_KEY4 = 'filter-pub-button';
const FILTER_KEY5 = 'filter-pub-page';

// API description for all commnication with BACK-END for campaigns management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                                          Actions                   View
//  GET       api/campaign                              get all campaigns


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class OffersService {
    constructor(private http: HttpClient) { }

    getOffers(filter: any): Observable<any> {
        return this.http.post(ADDRS_API + `/publishers/offers`, filter);
      }

    getOffer(offerId: any): Observable<any> {
        return this.http.get(ADDRS_API + `/publishers/offers/` + `${offerId}`);
      }

    // ustaw publishersStatus dla oferty
    updateOfferStatus(id: any, data: any): Observable<any> {
      return this.http.put(`${ADDRS_API}` + `/publishers/offers/` + `${id}` + `/status`, data);
    }

    // ----------------------------------------------
    // OBSŁUGA FILTRÓW
    // PUBLISHER-OFFERS
    public saveFilter(id: number, filter: any): void {
      switch(id){
        case 1: // filter type (categorise)
          window.sessionStorage.removeItem(FILTER_KEY1);
          window.sessionStorage.setItem(FILTER_KEY1, JSON.stringify(filter));
          break;

        case 2:  // filtr device
          window.sessionStorage.removeItem(FILTER_KEY2);
          window.sessionStorage.setItem(FILTER_KEY2, JSON.stringify(filter));
          break;

        case 3: // filtr country
          window.sessionStorage.removeItem(FILTER_KEY3);
          window.sessionStorage.setItem(FILTER_KEY3, JSON.stringify(filter));
          break;

        case 4: // button on/off
          window.sessionStorage.removeItem(FILTER_KEY4);
          window.sessionStorage.setItem(FILTER_KEY4, JSON.stringify(filter));
          break;

        case 5: // page
          window.sessionStorage.removeItem(FILTER_KEY5);
          window.sessionStorage.setItem(FILTER_KEY5, JSON.stringify(filter));
          break;
      }
    }

    public getFilter(id: number): any {
      switch(id) {
        case 1: // filter type (categorise)
          const filter1 = window.sessionStorage.getItem(FILTER_KEY1);
          if(filter1)
          {
            return JSON.parse(filter1);
          }
          return null;

        case 2: // filtr device
          const filter2 = window.sessionStorage.getItem(FILTER_KEY2);
          if(filter2)
          {
            return JSON.parse(filter2);
          }
          return null;

        case 3: // filtr country
          const filter3 = window.sessionStorage.getItem(FILTER_KEY3);
          if(filter3)
          {
            return JSON.parse(filter3);
          }
          return null;

        case 4: // button on/off
          const filter4 = window.sessionStorage.getItem(FILTER_KEY4);
          if(filter4)
          {
            return JSON.parse(filter4);
          }
          return null;

        case 5: // page
          const filter5 = window.sessionStorage.getItem(FILTER_KEY5);
          if(filter5)
          {
            return JSON.parse(filter5);
          }
          return null;
      }
    }
}
